import { accumulateStateFromMessages } from '../../rankings/components/state-utils.js';

export const CHARACTER_REMOVAL_PATTERNS = [
  /character\s+(\d+)\s+(?:has\s+)?(?:left|departed|gone|removed)/i,
  /(\w+)\s+(?:has\s+)?(?:left|departed|gone)/i
];

export const applyCharacterRemovalsFromSystemMessages = (characterMap, messages = []) => {
  for (const msg of messages || []) {
    if (msg.role !== 'system' || !msg.content) continue;
    for (const pattern of CHARACTER_REMOVAL_PATTERNS) {
      const match = msg.content.match(pattern);
      if (!match) continue;
      const identifier = match[1];
      if (/^\d+$/.test(identifier)) {
        characterMap.delete(identifier);
        continue;
      }
      const needle = identifier.toLowerCase();
      for (const [charId, char] of characterMap.entries()) {
        if (char.name?.toLowerCase().includes(needle)) {
          characterMap.delete(charId);
          break;
        }
      }
    }
  }
  return characterMap;
};

export const reconstructSessionStateFromMessages = async (messages, {
  hangoutConfig = {},
  fetchScenarioDetails
} = {}) => {
  let scenarioBaseline = null;
  if (hangoutConfig.scenarioId && fetchScenarioDetails) {
    try {
      scenarioBaseline = await fetchScenarioDetails(hangoutConfig.scenarioId);
    } catch (error) {
      console.warn('reconstructSessionStateFromMessages: Error fetching scenario baseline:', error);
    }
  }
  const baselineLocation = scenarioBaseline?.loc || scenarioBaseline?.loc_id || null;
  const accumulated = accumulateStateFromMessages(messages || []);
  const location = (accumulated.loc_id && accumulated.loc_id > 0) ? accumulated.loc_id : baselineLocation;

  const characters = new Map(
    (accumulated.activeCharacters || []).map((char) => [String(char.id), {
      id: String(char.id),
      name: char.name,
      outfitId: char.outfitId || 0,
      actionId: char.actionId ?? char.sprite_state ?? null,
      isActive: true
    }])
  );

  applyCharacterRemovalsFromSystemMessages(characters, messages);

  const finalCharacters = [...characters.values()].map((char) => ({
    ...char,
    outfitId: char.outfitId,
    actionId: char.actionId ?? null,
    goal: char.goal
  }));
  return {
    characters: finalCharacters,
    location,
    hasStateData: finalCharacters.length > 0 || location !== null
  };
};
